import Backdrop from "./Backdrop";
import Spacer from "./Spacer";
import sadEmojiGroup from "assets/images/sadEmojiGroup.svg";
import styled from "styled-components";

const Wrapper = styled(Backdrop)`
  z-index: 10;

  .card {
    width: 430px;
    padding: 48px;
    background-color: var(--white);
    border-radius: 16px;
  }

  .actionBtns {
    gap: 24px;
  }

  .btn {
    height: 48px;
    width: calc(50% - 12px);
    border-radius: 8px;
    padding: 0 24px;
    text-transform: capitalize;

    &.cancel {
      color: var(--body_text);
      border: 1px solid var(--body_text);
    }

    &.actionBtn {
      color: var(--white);
    }

    &.danger {
      background-color: var(--danger);
    }

    &.info {
      background-color: var(--primary);
    }

    &:disabled {
      background-color: var(--body_text);
    }
  }

  &.warning .card {
    background-color: #fffcf0;
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 48px);
      padding: 24px;

      .title {
        font-size: 16px;
        line-height: 20px;
      }

      .description {
        font-size: 14px;
        line-height: 20px;
      }

      .btn {
        min-width: unset;
        width: calc(50% - 24px);
      }
    }
  }
`;

const ConfirmModal = ({
  id = "confirmModal",
  title,
  action,
  description,
  actionText,
  callback,
  image,
  warning,
  type = "danger",
}) => {
  const handleAction = async () => {
    if (!callback) {
      return;
    }
    document.querySelector(`#${id}.confirmModal`).classList.remove("show");
    await callback();
  };
  return (
    <Wrapper
      id={id}
      className={`confirmModal flexRow alignCenter justifyCenter${
        warning ? " warning" : ""
      }`}
    >
      <div className="card flexColumn alignCenter">
        <img
          src={image || sadEmojiGroup}
          alt="."
          className="image"
        />
        <Spacer y={1.2} />
        {title ? (
          <h5 className="colorGrey1 textCenter title">{title}</h5>
        ) : (
          <h5 className="colorGrey1 textCenter title">
            Are you sure you want to
            <br />
            {action}?
          </h5>
        )}
        <Spacer y={1.2} />
        <p className="l2 colorBodyText textCenter description">{description}</p>
        <Spacer y={2.4} />
        <div className="flexRow justifyCenter fullWidth actionBtns">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document.querySelector(`#${id}.confirmModal`).classList.remove("show")
            }
          >
            Cancel
          </button>
          <button
            onClick={handleAction}
            className={`btn actionBtn flexRow alignCenter justifyCenter ${type}`}
          >
            {actionText}
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

export default ConfirmModal;
